import BannerInfo from 'components/BannerInfo';
import Card from 'components/Card';
import CompanySelection from 'components/CompanySelection';

const Company = () => {
  return (
    <>
      <Card>
      <CompanySelection />
      </Card>
      <BannerInfo />
    </>
  );
};

export default Company;
